import RBACSwitcher from "components/common/Auth/RBACSwitcher";
import Assistance from "components/common/Assistance";

const AssistancePage = () => {
  return (
    <RBACSwitcher
      admin={<Assistance userRole="adminStartup" />}
      student={<Assistance userRole="student" />}
      teacher={<Assistance userRole="teacher" />}
      school={<Assistance userRole="adminSchool" />}
      parent={<Assistance userRole="parent" />}
    />
  );
};

export default AssistancePage;
